// © 2023 Amazon Web Services, Inc. or its affiliates. All Rights Reserved.
// This AWS Content is provided subject to the terms of the AWS Customer Agreement available at
// http://aws.amazon.com/agreement or other written agreement between Customer and either
// Amazon Web Services, Inc. or Amazon Web Services EMEA SARL or both.
import React, { useEffect, useState } from "react";
import { Spin, Layout } from "antd";
import Nav from "./components/Navigation/Nav";
import home from "./media/Home.svg";
import "./index.css";
import { Button } from "@awsui/components-react";
import { initAuth, signInWithIdc } from "./auth/cognitoAuth";

const { Header, Content } = Layout;

function Home(props) {
  return (
    <Layout className="site-layout">
      <Header className="site-layout-background" style={{ padding: 0 }} />
      <Content className="layout">
        <Spin spinning={props.loading} size="large">
          <Button
            className="homebutton"
            variant="primary"
            onClick={() => signInWithIdc()}
          >
            Federated Sign In
          </Button>
          <img src={home} alt="Homepage" className="home" />
        </Spin>
      </Content>
    </Layout>
  );
}

function applyPayload(payload, setters) {
  const {
    setUser,
    setcognitoGroups,
    setUserId,
    setGroupIds,
    setGroups,
    setLoading,
  } = setters;
  if (!payload) {
    setUser(null);
    setLoading(false);
    return;
  }
  setUser(payload.email || payload["cognito:username"] || null);
  setcognitoGroups(payload["cognito:groups"] || []);
  setUserId(payload.userId || null);
  setGroupIds(
    payload.groupIds ? payload.groupIds.split(",").filter(Boolean) : []
  );
  setGroups(payload.groups ? payload.groups.split(",").filter(Boolean) : []);
  setLoading(false);
}

function App() {
  const [user, setUser] = useState(null);
  const [groups, setGroups] = useState(null);
  const [cognitoGroups, setcognitoGroups] = useState([]);
  const [userId, setUserId] = useState(null);
  const [groupIds, setGroupIds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const session = await initAuth();
        if (cancelled) return;
        applyPayload(session?.idTokenPayload || null, {
          setUser,
          setcognitoGroups,
          setUserId,
          setGroupIds,
          setGroups,
          setLoading,
        });
      } catch (err) {
        console.error("[App] auth init failed", err);
        if (!cancelled) {
          setUser(null);
          setLoading(false);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div>
      {user ? (
        <Nav
          user={user}
          groupIds={groupIds}
          userId={userId}
          groups={groups}
          cognitoGroups={cognitoGroups}
        />
      ) : (
        <Home loading={loading} />
      )}
    </div>
  );
}

export default App;
